// extracted by mini-css-extract-plugin
module.exports = {"shareholderInput":"shareholderInput__2LQbX","searchBox":"searchBox__32hxl","shareholderInputField":"shareholderInputField__3T2DB","headerText":"headerText__1JdSr"};